// src/pages/AuthCallback.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setErr(null);

        // Complete the session from the magic link / OAuth code.
        const { error } = await supabase.auth.exchangeCodeForSession(window.location.href);

        // If exchange failed, it might already be signed in. Verify before erroring out.
        if (error) {
          const { data } = await supabase.auth.getSession();
          if (!data.session) throw error;
        }

        // Pull next from URL first, then from sessionStorage (your SignIn flow may set it).
        const sp = new URLSearchParams(window.location.search);
        const next = sp.get("next") || sessionStorage.getItem("next") || "/dashboard";
        sessionStorage.removeItem("next");

        // Same-origin absolute URL? Use full navigation; relative path? Use SPA navigate.
        if (/^https?:\/\//i.test(next)) {
          window.location.replace(next);
        } else {
          navigate(next, { replace: true });
        }
      } catch (e: any) {
        setErr(e.message || String(e));
      }
    })();
  }, [navigate]);

  return (
    <div style={{ maxWidth: 520, margin: "60px auto", padding: 16 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700 }}>Signing you in…</h1>
      {err && <div style={{ marginTop: 12, color: "#b91c1c", whiteSpace: "pre-wrap" }}>{err}</div>}
    </div>
  );
}
